import React, { useRef, useEffect, useState, Fragment } from 'react';
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { BellIcon, MenuIcon, XIcon } from '@heroicons/react/outline'
import { Link, Outlet } from "react-router-dom";
import SlideOver from './components/SlideOver';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

function App() {

  const [open, setOpen] = useState(false);

  const navLinks = [
    {
      text: 'About',
      to: '#',
      active: false 
    },
    /*{
      text: 'Map',
      to: '',
      active: true
    }*/
  ]

  const mainLinks = [];

  const mobileLinks = [];

  navLinks.forEach(link => {
    
    /*mainLinks.push(<Link to={link.to} className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-3 pt-1 border-b-2 text-sm font-medium">{link.text}</Link>);
    
    mobileLinks.push(<Link to={link.to} className="border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700 block pl-3 pr-4 py-2 border-l-4 text-base font-medium">{link.text}</Link>);*/

    mainLinks.push(<a href={link.to} className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-3 pt-1 border-b-2 text-sm font-medium" onClick={() => setOpen(true)}>About</a>);
  });

  

  return (
    <div className="App text-slate-700">
      <Disclosure as="nav" className="bg-slate-50 shadow font-serif z-40">
        {({ open }) => (
          <>
            <div className="px-4 sm:px-2 lg:px-2 z-40">
              <div className="relative flex justify-between h-16 z-40">
                <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                  {/* Mobile menu button */}
                  <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500">
                    <span className="sr-only">Open main menu</span>
                    {open ? (
                      <XIcon className="block h-6 w-6" aria-hidden="true" />
                    ) : (
                      <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                    )}
                  </Disclosure.Button>
                </div>
                <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-between">
                  <div className="flex-shrink-0 flex items-center">
                    <h1 className="text-2xl italic font-thin ml-4">Lingua Botanica | <span className="font-thin">Mapping Historical Biodiversity through Text Analysis</span></h1>
                  </div>
                  <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
                    {/* Current: "border-indigo-500 text-gray-900", Default: "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" */}
                    {mainLinks}
                  </div>
                </div>
              </div>
            </div>

            <Disclosure.Panel className="sm:hidden">
              <div className="pt-2 pb-4 mr-4 space-y-1">
                {/* Current: "bg-indigo-50 border-indigo-500 text-indigo-700", Default: "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700" */}
                {mobileLinks}
              </div>
            </Disclosure.Panel>
          </>
        )}
      </Disclosure>
      <SlideOver open={open} setOpen={setOpen}/>
      <Outlet />
  </div>
  )
}

export default App;
